import {RuleParamsMap, MultiParamsRules} from './RuleParamsMap'
import Validator from './Validator'

export default class FieldRule
{
    constructor( name, options = {} ) {
        this.setName(name)
        this.params = {}
        this.type = FieldRule.TYPE_ERROR
        this.not = false // used to inverse the validation logic
        this.skipOnEmpty = undefined
        this._emptyOn = undefined
        this.errorMessage = null
        this._when = undefined

        // apply default values
        Object.keys(options).forEach( key => {

            if( key === 'when' ) {
                this.setWhen(options.when)
                return
            }

            if( key === 'emptyOn' ) {
                this.setEmptyOn(options.emptyOn)
                return
            }

            if( key === 'name' ) {
                this.setName(options.name)
                return
            }

            if( key === 'params' ) {
                this.setParams(options.params)
                return
            }

            this[key] = options[key]
        })
    }

    static get TYPE_ERROR() {
      return 'error';
    }

    static get TYPE_WARNING() {
      return 'warning';
    }

    setName( name ) {
        if( typeof RuleParamsMap[name] === 'undefined' ) {
            console.error('[Validator]: Invalid validator name "' + name + '".')
        }

        this.name = name
        return this
    }

    setParams( params = [] ) {
        if( ! Array.isArray(params) || inArray(this.name, MultiParamsRules) )
            params = [params]

        for(let index in params) {
            if( typeof RuleParamsMap[this.name][index] === 'undefined' ) {
                console.error('[Validator]: Invalid params for validator "' + this.name + '".')
            }

            let paramName = RuleParamsMap[this.name][index]
            let paramValue = params[index]

            this.params[paramName] = paramValue
        }

        return this
    }

    when( $validator, fieldNameUnderValidation, index ) {
        if( ! this.hasWhen() )
            return true

        let condition = this._when

        let validateRules = (rules) => {
            let validatorInstance = new Validator(
                $validator.form(),
                [],
                $validator.getScenario(),
                $validator.getLanguage(),
                $validator.getUniqueKeyParam(),
                /*applyDefaultValues*/false
            )
            .setRules(
                rules,
                $validator._getParentFieldName(fieldNameUnderValidation, null)
            )

            return validatorInstance.validate().then(
                result => {
                    return Promise.resolve(result.valid)
                }
            )
        }

        if( isArray(condition) )
        {
            return validateRules(
                // clone array in 2 levels, because "fields" (first element) will be removed
                [...condition].map(ruleSet => [...ruleSet])
            )
        }
        else if( isObject(condition) ) {
            let result = []
            Object.keys(condition).forEach( field => {
                let value = $validator.form().getDeep(field)

                result.push(
                    Promise.resolve(condition[field]( value, $validator, fieldNameUnderValidation, index ))
                )
            })
            return Promise.all(result)
        }
        else if ( condition instanceof Function ) {
            let result = condition( $validator.form(), fieldNameUnderValidation, index )

            if( isArray(result) ) {
                return validateRules( result )
            }

            return result
        }
        else if ( typeof condition === "boolean" ) {
            return condition
        }

        return true
    }

    hasWhen() {
        return this._when !== undefined && this._when !== true
    }

    setWhen( condition ) {
        if( ! (isObject(condition) || isArray(condition) || condition instanceof Function || typeof condition === "boolean") ) {
            console.error('[Validator]: Invalid `when` condition "'+ condition +'". When condition must be: boolean, rules array, object (with field name as key) or a function.')
        }

        this._when = condition
        return this
    }

    // ------------------------- //

    isEmpty( value ) {
        if( this.hasEmptyOn() ) {
            return this._emptyOn( value )
        }

        // default behavior
        return isEmpty( value )
    }

    hasEmptyOn() {
        return this._emptyOn !== undefined
    }

    setEmptyOn( callback ) {
        if( ! callback instanceof Function ) {
            console.error('[Validator]: Invalid `emptyOn` callback "'+ callback +'". emptyOn condition must be a function.')
        }

        this._emptyOn = callback
        return this
    }
}
